import React, { useState } from 'react';
import { financeService } from './financeService';

export const FinancialForensicsUI: React.FC = () => {
  const [filter, setFilter] = useState({
    company_id: '',
    type: 'DEDUCTION',
    date_start: '',
    date_end: ''
  });
  const [results, setResults] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [trace, setTrace] = useState<any>(null);

  const handleSearch = async () => {
    setLoading(true);
    try {
      const data = await financeService.searchForensics(filter);
      setResults(data);
    } catch (err: any) {
      alert('Search failed: ' + (err.message || 'Error'));
    } finally {
      setLoading(false);
    }
  };

  const handleTrace = async (ledgerId: string) => {
    try {
      const data = await financeService.traceLedger(ledgerId);
      setTrace(data);
    } catch (err: any) {
      alert('Trace failed: ' + (err.message || 'Error'));
    }
  };

  return (
    <div className="module-audit">
      <h3>Financial Forensics & Ledger Trace</h3>
      
      <div className="search-bar">
        <input 
          placeholder="Company ID (optional)"
          value={filter.company_id}
          onChange={e => setFilter({ ...filter, company_id: e.target.value })}
        />
        <select 
          value={filter.type}
          onChange={e => setFilter({ ...filter, type: e.target.value })}
        >
          <option value="DEDUCTION">Deduction</option>
          <option value="TOPUP">Top-up</option>
          <option value="REFUND">Refund</option>
        </select>
        <button onClick={handleSearch} disabled={loading}>Search Ledger</button>
      </div>

      <div className="forensics-content">
        <div className="ledger-results">
          <h4>Ledger Entries</h4>
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Type</th>
                <th>Amount (₹)</th>
                <th>Tokens</th>
                <th>Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {results.map(entry => (
                <tr key={entry.id}>
                  <td>{entry.id.substring(0, 8)}...</td>
                  <td>{entry.transaction_type}</td>
                  <td>{entry.amount_inr}</td>
                  <td>{entry.tokens_involved}</td>
                  <td>{new Date(entry.created_at).toLocaleString()}</td>
                  <td>
                    <button onClick={() => handleTrace(entry.id)}>Trace</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {trace && (
          <div className="trace-details">
            <h4>Trace Root Cause: {trace.ledger_id.substring(0, 8)}</h4>
            <div className="trace-path">
              <div className="trace-node">
                <label>Source Transaction</label>
                <p>{trace.transaction_type}: ₹{trace.amount_inr}</p>
              </div>
              <div className="trace-node">
                <label>Linked Invoice</label>
                <p>{trace.invoice_number || 'N/A'}</p>
              </div>
              <div className="trace-node">
                <label>Active Contract</label>
                <p>{trace.contract_name || 'Individual Plan'}</p>
              </div>
              <div className="trace-node">
                <label>Usage Root Cause</label>
                <p>{trace.usage_event?.feature_name} by user {trace.usage_event?.user_id}</p>
              </div>
            </div>
            <button onClick={() => setTrace(null)}>Close Trace</button>
          </div>
        )}
      </div>
    </div>
  );
};
